// extracted by mini-css-extract-plugin
export default {"smallButton":"Button_smallButton__Wo2Ua"};